import MaterialUiRemoteTable from "../../../Components/Table/MaterialUiRemoteTable";
import React, {useContext, useEffect, useRef, useState} from "react";
import {ErrorsClient} from "../Service/ErrorsClient";
import useErrors from "../Hooks/UseErrors";
import {ErrorsProvider} from "../Context/ErrorsContext";
import moment from "moment/moment";
import {DATE, MULTI_SELECT, NUMBER, SELECT, TEXT} from "../Constants/Constants";
import {Badge} from "react-bootstrap";
import {setIsPreparingExcelData} from "../../../General/SharedMethods";
import {SupportUsersService} from "../../../General/SupportUsersService";
import {DateTime} from "luxon";
import {DATE_LOCALE, WINT_AI_CONTROL_URL, WINT_ORGANIZATIONS_ROUTE, WINT_SITES_ROUTE, WINT_WATER_SYSTEMS_ROUTE} from "../../../Constants/constants";
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {issuesFilterOptions} from "../../../Enums/ErrorsPage/issueType";
import {activeFilterOptions} from "../../../Enums/ErrorsPage/ended";
import {getAllAccountsCountries} from "../../../General/Countries";
import {waterSystemAcFilterOptions} from "../../../Enums/ErrorsPage/powerSource";
import CustomDateFilter from "./CustomDateFilter";
import LinkToSalesForcePopoverEdit from "./LinkToSalesForcePopoverEdit";
import AssigneeDropdown from "./AssigneeDropdown";
import CustomNumberFilter from "./CustomNumberFilter";
import {typeOfValveOptions} from "../../../Enums/ErrorsPage/typeOfValve";
import {meterTypeFilterOptions} from "../../../General/SharedMethods";
import {modeTypeOptions} from '../../../Enums/ErrorsPage/modeType';
import {deviceTypeOptions} from "../../../Enums/ErrorsPage/deviceType";
import {IconButton, Tooltip} from "@mui/material";
import {systemCycleOptions} from "../../../General/SystemLifeCycleStates";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {RingSpinnerOverlay} from "react-spinner-overlay";
import {store} from "../../../Store/store";
import {blue} from "@mui/material/colors";

const ErrorPage = () => {
    const {getErrors, updateError} = useErrors();
    const [supportUsers, setSupportUsers] = useState([]);
    const supportUsersService = new SupportUsersService(process.env.REACT_APP_SUPPORT_DASHBOARD_USERS_URL);
    const defaultFilters = [{
        id: 'lifecyclePhase',
        value: ['Commissioned - Learning', 'Commissioned - In Service', 'Commissioned, Water Meter not tested']
    }];
    const customRowPerPageOptions = [13, 20, 30, 50, 100];
    const [columnFilters, setColumnFilters] = useState(defaultFilters);
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({pageIndex: 0, pageSize: 13});
    const [countriesFilterOptions, setCountriesFilterOptions] = useState([]);
    const [isInactiveErrorsHidden, setIsInactiveErrorsHidden] = useState(false);
    const [isErrorsLoaded, setIsErrorsLoaded] = useState(false);
    const [columnVisibility, setColumnVisibility] = useState({lifecyclePhase: false});
    const globalState = useContext(store);
    const {dispatch} = useContext(store);
    const stringColumns = [
        "id",
        "organizationName",
        "siteName",
        "country",
        "timeZone",
        "offset",
        "waterSystemName",
        "powerSource",
        "userName",
        "address",
        "valveIndication",
        "typeOfValve",
        "hardwareId",
        "systemMode",
        "deviceType",
        "userCellPhoneNumber",
        "lastValveErrorUpdate",
        "restarting",
        "lastSmsReceivedAt",
        "lastBatteryIncrease",
        "lastBatteryDecrease",
        "errorType",
        "createdAt",
        "endedAt",
        "firstOccurrence",
        "previousOccurrence",
        "assignee",
        "remarks",
        "linkToSalesForce",
        "updatedAt",
        "lifecyclePhase"
    ];

    const dateFormatter = (cell) => {
        if (!cell.getValue()) {
            return null;
        }
        return moment(cell.getValue()?.toString()).format('lll')
    }

    const isEndedFormatter = (cell, row) => {
        const value = cell.renderValue();
        let variant = (value) ? 'success' : 'danger';
        let displayValue = (value) ? 'Inactive' : 'Active';

        return <Badge variant={variant}>{displayValue}</Badge>
    }

    const waterSystemFormatter = (cell, row) => {
        let href = `${WINT_AI_CONTROL_URL}/${WINT_SITES_ROUTE}/${row.original.siteId}/${WINT_WATER_SYSTEMS_ROUTE}/${row.original.waterSystemId}`;
        return <a target="_blank" rel="noreferrer" href={href}>{row.original.waterSystemName}</a>
    }

    const siteFormatter = (cell, row) => {
        let href = `${WINT_AI_CONTROL_URL}/${WINT_SITES_ROUTE}/${row.original.siteId}`;
        return <a target="_blank" rel="noreferrer" href={href}>{row.original.siteName}</a>
    }

    const organizationFormatter = (cell, row) => {
        let href = `${WINT_AI_CONTROL_URL}/${WINT_ORGANIZATIONS_ROUTE}/${row.original.organizationId}/`;
        return <a target="_blank" rel="noreferrer" href={href}>{row.original.organizationName}</a>
    }

    const handleUpdateCell = (id, field, value, data) => {
        updateError({
            id: id,
            assignee: field === 'assignee' ? value : null,
            remarks: field === 'remarks' ? value : null,
            linkToSalesForce: field === 'linkToSalesForce' ? value : null
        })
    }

    const handleUpdateCellCallBack = (id, field, value, data) => {
        handleUpdateCell(id, field, value, data);
    }

    const getCountriesFilter = async () => {
        let countries = [];
        await getAllAccountsCountries().then((response) => {
            response.forEach(country => {
                countries.push({value: country, label: country});
            })
        });

        setCountriesFilterOptions(countries);
    }

    const multiSelectCellRenderer = (filterOptions, cellValue) => {
        return filterOptions.find((obj) => obj.value === cellValue)?.label
    }

    const toggleShowActiveErrors = () => {
        setIsInactiveErrorsHidden(!isInactiveErrorsHidden);
    }

    const renderCustomToolBarActions = () => {
        return isInactiveErrorsHidden ?
            <Tooltip title='Hide Inactive Errors'>
                <IconButton onClick={() => toggleShowActiveErrors()}>
                    <VisibilityOffIcon/>
                </IconButton> </Tooltip> :
            <Tooltip title='Show Inactive Errors'>
                <IconButton onClick={() => toggleShowActiveErrors()}>
                    <VisibilityIcon/>
                </IconButton>
            </Tooltip>
    }

    useEffect(() => {
        setIsPreparingExcelData(dispatch, false);
        getCountriesFilter();
    }, [])

    const columns = React.useMemo(() => [
        {
            accessorKey: 'lifecyclePhase',
            header: 'System Life Cycle State',
            excelHeader: 'System Life Cycle State',
            filterSelectOptions: systemCycleOptions.map(option => option.label),
            enumArray: systemCycleOptions,
            filterVariant: MULTI_SELECT,
            filterFn: () => null, // must include this in order for custom filter to work
        },
        {
            accessorKey: 'updatedAt',
            header: 'Last Update',
            excelHeader: 'Last Update',
            Cell: ({cell}) => (dateFormatter(cell)),
            filterVariant: DATE,
            Filter: ({header}) => CustomDateFilter(header, columnFilters, 'updatedat'),
            filterFn: () => null,
            enableEditing: false,
            minSize: 230,
        },
        {
            accessorKey: 'assignee',
            header: 'Assignee',
            excelHeader: 'Assignee',
            filterVariant: SELECT,
            filterSelectOptions: supportUsers.map((user) => ({label: user.name, value: user.name})),
            enumArray: supportUsers.map((user) => ({label: user.name, value: user.name})),
            filterFn: () => null,
            Cell: ({cell, row, rowIndex}) => (
                <AssigneeDropdown
                    cell={cell}
                    row={row}
                    rowIndex={rowIndex}
                    supportUsers={supportUsers}
                    handleUpdateCellCallBack={handleUpdateCellCallBack}
                />
            ),
        },
        {
            accessorKey: 'linkToSalesForce',
            header: 'Salesforce Link',
            excelHeader: 'Salesforce Link',
            Cell: ({cell, row}) => (
                <LinkToSalesForcePopoverEdit
                    cell={cell}
                    row={row}
                    handleUpdateCellCallBack={handleUpdateCellCallBack}
                />
            ),
            filterVariant: TEXT,
            filterFn: () => null,
        },
        {
            accessorKey: 'deviceType',
            header: 'Device',
            excelHeader: 'Device',
            Cell: ({cell}) => multiSelectCellRenderer(deviceTypeOptions, cell?.getValue()),
            filterSelectOptions: deviceTypeOptions.map(option => option.label),
            filterVariant: MULTI_SELECT,
            enumArray: deviceTypeOptions,
            filterFn: () => null,

        },
        {
            accessorKey: 'errorType',
            header: 'Issue',
            excelHeader: 'Issue',
            Cell: ({cell}) => multiSelectCellRenderer(issuesFilterOptions, cell?.getValue()),
            filterSelectOptions: issuesFilterOptions.map(option => option.label),
            enumArray: issuesFilterOptions,
            filterVariant: MULTI_SELECT,
            filterFn: () => null,
        },
        {
            accessorKey: 'ended',
            header: 'Active',
            excelHeader: 'Active',
            filterSelectOptions: activeFilterOptions.map(option => option.label),
            enumArray: activeFilterOptions,
            filterVariant: SELECT,
            Cell: ({cell}) => isEndedFormatter(cell),
            filterFn: () => null,
        },
        {
            accessorKey: 'createdAt',
            header: 'Created At',
            excelHeader: 'Created At',
            Cell: ({cell}) => (dateFormatter(cell)),
            filterVariant: DATE,
            Filter: ({header}) => CustomDateFilter(header, columnFilters, 'createdat'),
            filterFn: () => null,
            minSize: 230,
        },
        {
            accessorKey: 'endedAt',
            header: 'Ended At',
            excelHeader: 'Ended At',
            filterVariant: DATE,
            Filter: ({header}) => CustomDateFilter(header, columnFilters, 'endedat'),
            filterFn: () => null,
            Cell: ({cell}) => dateFormatter(cell),
            minSize: 230,
        },
        {
            accessorKey: 'hardwareId',
            header: 'Hardware ID',
            excelHeader: 'Hardware ID',
            filterVariant: TEXT,
            filterFn: () => null,
        },
        {
            accessorKey: 'organizationName',
            header: 'Organization',
            excelHeader: 'Organization',
            filterVariant: TEXT,
            Cell: ({cell, row}) => organizationFormatter(cell, row),
            filterFn: () => null,
        },
        {
            accessorKey: 'siteName',
            header: 'Site',
            excelHeader: 'Site',
            filterVariant: TEXT,
            Cell: ({cell, row}) => siteFormatter(cell, row),
            filterFn: () => null,
        },
        {
            accessorKey: 'waterSystemName',
            header: 'Water System',
            excelHeader: 'Water System',
            filterVariant: TEXT,
            Cell: ({cell, row}) => waterSystemFormatter(cell, row),
            filterFn: () => null,
        },
        {
            accessorKey: 'country',
            header: 'Country',
            excelHeader: 'Country',
            filterSelectOptions: countriesFilterOptions.map(option => option.label),
            filterVariant: MULTI_SELECT,
            enumArray: countriesFilterOptions,
            filterFn: () => null,
        },
        {
            accessorKey: 'timeZone',
            header: 'Time Zone',
            excelHeader: 'Time Zone',
            enableColumnFilter: false,
            enableSorting: false,
            filterFn: () => null,
        },
        {
            accessorKey: 'powerSource',
            header: 'AC Power',
            excelHeader: 'AC Power',
            Cell: ({cell}) => multiSelectCellRenderer(waterSystemAcFilterOptions, cell?.getValue()),
            filterVariant: SELECT,
            filterSelectOptions: waterSystemAcFilterOptions.map(option => option.label),
            enumArray: waterSystemAcFilterOptions,
            filterFn: () => null,
        },
        {
            accessorKey: 'batteryVoltage',
            header: 'Battery (V)',
            excelHeader: 'Battery (V)',
            Filter: ({header}) => CustomNumberFilter(header, columnFilters, 'batteryvoltage'),
            filterFn: () => null,
            filterVariant: NUMBER,
            minSize: 220,
        },
        {
            accessorKey: 'batteryValue',
            header: 'Battery',
            excelHeader: 'Battery',
            Filter: ({header}) => CustomNumberFilter(header, columnFilters, 'batteryvalue'),
            filterFn: () => null,
            filterVariant: NUMBER,
            minSize: 220,
        },
        {
            accessorKey: 'softwareVersion',
            header: 'Version',
            excelHeader: 'Version',
            Filter: ({header}) => CustomNumberFilter(header, columnFilters, 'softwareversion'),
            filterFn: () => null,
            filterVariant: NUMBER,
            minSize: 220,
        },
        {
            accessorKey: 'rssi',
            header: 'RSSI',
            excelHeader: 'RSSI',
            Filter: ({header}) => CustomNumberFilter(header, columnFilters, 'rssi'),
            filterFn: () => null,
            filterVariant: NUMBER,
            minSize: 220,
        },
        {
            accessorKey: 'userName',
            header: 'User Name',
            excelHeader: 'User Name',
            filterVariant: TEXT,
            filterFn: () => null,
        },
        {
            accessorKey: 'address',
            header: 'Address',
            excelHeader: 'Address',
            filterVariant: TEXT,
            filterFn: () => null,
        },
        {
            accessorKey: 'typeOfValve',
            header: 'Valve Type',
            excelHeader: 'Valve Type',
            Cell: ({cell}) => multiSelectCellRenderer(typeOfValveOptions, cell?.getValue()),
            filterSelectOptions: typeOfValveOptions.map(option => option.label),
            filterVariant: MULTI_SELECT,
            enumArray: typeOfValveOptions,
            filterFn: () => null,
        },
        {
            accessorKey: 'valvesCount',
            header: '# of Valves',
            excelHeader: '# of Valves',
            Filter: ({header}) => CustomNumberFilter(header, columnFilters, 'valvescount'),
            filterFn: () => null,
            filterVariant: NUMBER,
            minSize: 220,
        },
        {
            accessorKey: 'meterType',
            header: 'Meter Type',
            excelHeader: 'Meter Type',
            Cell: ({cell}) => multiSelectCellRenderer(meterTypeFilterOptions(), cell?.getValue()?.toString()),
            filterSelectOptions: meterTypeFilterOptions().map(option => option.label),
            filterVariant: MULTI_SELECT,
            enumArray: meterTypeFilterOptions(),
            filterFn: () => null
        },
        {
            accessorKey: 'systemMode',
            header: 'Mode',
            excelHeader: 'Mode',
            Cell: ({cell}) => multiSelectCellRenderer(modeTypeOptions, cell?.getValue()),
            filterSelectOptions: modeTypeOptions.map(option => option.label),
            filterVariant: MULTI_SELECT,
            enumArray: modeTypeOptions,
            filterFn: () => null
        },
        {
            accessorKey: 'userCellPhoneNumber',
            header: 'User Cellphone',
            excelHeader: 'User Cellphone',
            filterVariant: TEXT,
            filterFn: () => null
        },
        {
            accessorKey: 'lastValveErrorUpdate',
            header: 'Valve Error Last Update',
            excelHeader: 'Valve Error Last Update',
            filterVariant: DATE,
            Filter: ({header}) => CustomDateFilter(header, columnFilters, 'lastvalveerrorupdate'),
            filterFn: () => null,
            Cell: ({cell}) => dateFormatter(cell),
            minSize: 230,
        },
        {
            accessorKey: 'lastSmsReceivedAt',
            header: 'Last SMS',
            excelHeader: 'Last SMS',
            filterVariant: DATE,
            Filter: ({header}) => CustomDateFilter(header, columnFilters, 'lastsmsreceivedat'),
            filterFn: () => null,
            Cell: ({cell}) => dateFormatter(cell),
            minSize: 230,
        },
        {
            accessorKey: 'firstOccurrence',
            header: 'First Error Occurred',
            excelHeader: 'First Error Occurred',
            filterVariant: DATE,
            Filter: ({header}) => CustomDateFilter(header, columnFilters, 'firstoccurrence'),
            filterFn: () => null,
            Cell: ({cell}) => dateFormatter(cell),
            minSize: 230,
        },
        {
            accessorKey: 'previousOccurrence',
            header: 'Previous Error Occurred',
            excelHeader: 'Previous Error Occurred',
            filterVariant: DATE,
            Filter: ({header}) => CustomDateFilter(header, columnFilters, 'previousoccurrence'),
            filterFn: () => null,
            Cell: ({cell}) => dateFormatter(cell),
            minSize: 230,
        },
        {
            accessorKey: 'lastBatteryIncrease',
            header: 'Last Battery Increase',
            excelHeader: 'Last Battery Increase',
            filterVariant: DATE,
            Filter: ({header}) => CustomDateFilter(header, columnFilters, 'lastbatteryincrease'),
            filterFn: () => null,
            Cell: ({cell}) => dateFormatter(cell),
            minSize: 230,
        },
        {
            accessorKey: 'lastBatteryDecrease',
            header: 'Last Battery Decrease',
            excelHeader: 'Last Battery Decrease',
            filterVariant: DATE,
            Filter: ({header}) => CustomDateFilter(header, columnFilters, 'lastbatterydecrease'),
            filterFn: () => null,
            Cell: ({cell}) => dateFormatter(cell),
            minSize: 230,
        },
        {
            accessorKey: 'valveTimeout',
            header: 'Valve Timeout',
            excelHeader: 'Valve Timeout',
            Filter: ({header}) => CustomNumberFilter(header, columnFilters, 'valvetimeout'),
            filterFn: () => null,
            filterVariant: NUMBER,
            minSize: 220,
        },
    ], [supportUsers, columnFilters, countriesFilterOptions]);

    const excelColumns = React.useMemo(() => [
        {id: 'organizationId', displayName: 'Organization Id'},
        {id: 'siteId', displayName: 'Site Id'},
        {id: 'waterSystemId', displayName: 'Water System Id'},
        ...columns.map(col => ({
            id: col.accessorKey,
            displayName: col.excelHeader,
        })),
    ],[columns])

    useEffect(() => {
        getSupportUsers();
    }, [])

    const getSupportUsers = () => {
        supportUsersService.getAllUsers().then(response => {
            setSupportUsers(response);
        });
    }

    return <>
        {isErrorsLoaded ?
            <RingSpinnerOverlay
                loading={globalState.state.isPreparingExcelData}
                message={'Preparing excel file..'}
                color={blue[500]}
            /> : null}
        <MaterialUiRemoteTable
            customRowPerPageOptions={customRowPerPageOptions}
            columns={columns}
            csvFileName={`Errors_Report_${DateTime.local().toLocaleString({locale: DATE_LOCALE})}.csv`}
            getData={getErrors}
            columnFilters={columnFilters}
            sorting={sorting}
            pagination={pagination}
            setColumnFilters={setColumnFilters}
            additionalDataArguments={[isInactiveErrorsHidden]}
            setIsErrorsLoaded={setIsErrorsLoaded}
            setSorting={setSorting}
            setPagination={setPagination}
            renderAdditionalCustomToolBarActions={renderCustomToolBarActions}
            textFieldNames={stringColumns}
            excelColumns={excelColumns}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
        />
    </>
}

export const ErrorsProviders = () => {
    const errorsClientRef = useRef(new ErrorsClient(`${process.env.REACT_APP_SUPPORT_DASHBOARD_ERRORS_URL}`));
    if (errorsClientRef.current) {
        return <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ErrorsProvider errorsClientRef={errorsClientRef.current}>
                <ErrorPage/>
            </ErrorsProvider>
        </LocalizationProvider>
    } else {
        return null
    }
};

export default ErrorsProviders
